// extracted by mini-css-extract-plugin
export var md = "_6x-4";
export var semantic = "_6x-5";
export var sm = "_6x-3";
export var text = "_6x-6";
export var toggleInput = "_6x-0";
export var toggleSwitch = "_6x-1";
export var xs = "_6x-2";